import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import * as ApiHome from '../interfaces/api/home';

@Injectable({
  providedIn: 'root',
})
export class HomeService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  getRollingCover(type: string = null) {
    const url = new URL(`${this.apiUrl}/rolling-cover`);

    if (type) {
      url.searchParams.set('type', type);
    }

    return this.http.get<ApiHome.ResponseBody>(url.href);
  }

  getBanners(order_type?: 'desc' | 'asc') {
    return this.http.get<ApiHome.GetBannersResponse>(
      `${this.apiUrl}/banner?order_type=${order_type ? order_type : 'desc'}`,
    );
  }

  getBrands() {
    return this.http.get<ApiHome.Brand[]>(`${this.apiUrl}/brand`);
  }
}
